import { css } from 'styled-components';
import { CFBaseTabTokens } from './Tab.styles';
import { CFTokens } from '../../tokens';
//
// Tokens
//
export const CFBaseTabsTokens = {};
//
// Helpers
//
export const CFBaseTabsHelpers = {
    alignment: ({ $alignment }) => {
        switch ($alignment) {
            case 'left':
                return 'flex-start';
            case 'right':
                return 'flex-end';
            case 'center':
            default:
                return 'center';
        }
    },
    animatedBarColor: ({ $alternateTheme, $customTheme, }) => {
        let borderColor = CFBaseTabTokens.BORDER_COLORS[$alternateTheme ? 'ALTERNATE' : 'DEFAULT']
            .ACTIVE;
        if ($customTheme === null || $customTheme === void 0 ? void 0 : $customTheme.activeBorderColor)
            borderColor = CFTokens.getCFColorValue($customTheme.activeBorderColor, borderColor);
        return css `
      border: 1px solid ${borderColor};
    `;
    },
    animatedBarWeb: ({ $width, $left, $opacity, }) => css `
    width: ${$width}px;
    left: ${$left}px;
    opacity: ${$opacity};
  `,
};
//
// Element Styles
//
export const CFBaseTabsStyles = {
    AnimatedBar: css `
    position: absolute;
    bottom: 0;
    ${CFBaseTabsHelpers.animatedBarColor}
  `,
    AnimatedBarWeb: css `
    transition-property: width, left, opacity, border-color;
    transition-duration: 100ms;
    transition-timing-function: ease-in;
    ${CFBaseTabsHelpers.animatedBarWeb}
  `,
    Root: css `
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: ${CFBaseTabsHelpers.alignment};
    position: relative;
    gap: ${CFTokens.SPACER.E}px;
  `,
};
